// Carry Roll FittingAssumptions — roll-% assumptions by category + ball-type selector (6.5, 6.7).

import { Select } from 'calc-controls';
import { rollPercentByCategory } from '@carry-roll/shared-logic';
import { ClubCategory } from '@carry-roll/shared-types';
import { BALL_MODIFIERS, type BallType } from '@carry-roll/shared-logic';
import { useStore } from '../../store';
import { HelpTooltip } from '../calculator/HelpTooltip';

export function FittingAssumptions() {
  const ballType = useStore((s) => s.request.ballType);
  const setBallType = useStore((s) => s.setBallType);

  return (
    <div data-testid="fitting-assumptions">
      <h3 className="subsection-title">
        Fitting assumptions
      </h3>

      <div className="mb-3">
        <div className="block">
          <span className="field-label">
            Ball type
            <HelpTooltip label="Ball type">Equipment model applied to drag, lift, spin retention, and ball speed. Tour is the neutral baseline.</HelpTooltip>
          </span>
          <Select
            inline
            label="Ball type"
            value={ballType}
            onChange={(v) => setBallType(v as BallType)}
            options={(Object.keys(BALL_MODIFIERS) as BallType[]).map((bt) => ({
              value: bt,
              label: BALL_MODIFIERS[bt]!.label,
            }))}
          />
        </div>
      </div>

      <h4 className="text-sm font-medium mb-1" style={{ color: 'var(--color-text-muted)' }}>
        Roll-% by category
      </h4>
      <ul className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
        {Object.values(ClubCategory).map((cat) => (
          <li key={cat}>
            {cat}: {Math.round(rollPercentByCategory(cat) * 100)}% of carry
          </li>
        ))}
      </ul>
    </div>
  );
}
